import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { AddonUsageResponse, AddonUsageResponseSchema } from '../../../pb/responses/v1/addon_usage_response_pb';

export const fetchAddonUsage = async (): Promise<AddonUsageResponse> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient.getRequest(AddonUsageResponseSchema, '/api/v1/subscriptions/addons/usage').then((res) => res);
};
